import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

import { PatientRemoveForm } from './PatientRemoveForm';
import { PatientRemoveAction } from './PatientRemoveModal.actions';
import { PatientCannotBeRemovedModalOpener } from './PatientCannotBeRemovedModal.opener';

type PatientRemoveModalProps = {
   readonly patient: PatientSimple;
   readonly onCancel: VoidFunction;
   readonly onPatientRemoved: VoidFunction;
};

export const PatientRemoveModal = (props: PatientRemoveModalProps): JSX.Element => {
   return (
      <Modal
         title={patientTranslationKeys.removePatient}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'patientRemove'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <PatientRemoveForm patient={props.patient}>
            {({ handleSubmit, formState }) => (
               <>
                  <PatientCannotBeRemovedModalOpener>
                     {({ openModal }) => (
                        <PatientRemoveAction
                           onSuccess={props.onPatientRemoved}
                           patientId={props.patient.id}
                           onPatientCannotBeRemovedFault={openModal}
                        >
                           {({ removePatient }) => (
                              <ModalConfirmButton
                                 label={patientTranslationKeys.removePatient}
                                 onClick={handleSubmit(removePatient)}
                              />
                           )}
                        </PatientRemoveAction>
                     )}
                  </PatientCannotBeRemovedModalOpener>

                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />
                  <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PatientRemoveForm>
      </Modal>
   );
};
